import axios from '../utils/axios'

export const postPayment = async (data = {})=>{
    try {
        const response = await axios.post('/payments', data);
        const { success, message } = response.data;
        return {
            success,
            message
        }
      } catch (error) {
        console.error(error);
        return {}
      }
}

export const getNotificationPayment = async ()=>{
    try {
        const response = await axios.get('/payments/notification');
        const { success, message ,paymentsNotification} = response.data;
        return {
            success,
            message,
            paymentsNotification
        }
      } catch (error) {
        console.error(error);
        return {}
      }
}

export const putPayment = async (data = {})=>{
    try {
        const response = await axios.put('/payments', data);
        const { success, message } = response.data;
        return {
            success,
            message
        }
      } catch (error) {
        console.error(error);
        return {}
      }
}

export const getPayments = async (filters = {})=>{
    try {
        const response = await axios.get('/payments', {params: filters});
        const { payments, success, dataLength } = response.data;
        return {
            payments, 
            success,
            dataLength
        }
    } catch (error) {
        console.error(error);
        return {}
    }
}